<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-info">
    <path d="M7 0C3.1402 0 0 3.1402 0 7C0 10.8598 3.1402 14 7 14C10.8598 14 14 10.8596 14 7C14 3.1402 10.8598 0 7 0ZM7 13.2546C3.55118 13.2546 0.745422 10.4487 0.745422 7C0.745422 3.55133 3.55118 0.745422 7 0.745422C10.4487 0.745422 13.2546 3.55133 13.2546 7C13.2546 10.4487 10.4487 13.2546 7 13.2546Z" :fill="color"/>
    <path d="M6.86005 4.87636C7.31987 4.87636 7.65354 4.5402 7.65339 4.08458C7.66334 3.86898 7.58587 3.65322 7.44665 3.50716C7.31007 3.3642 7.11936 3.28876 6.89552 3.28876C6.35107 3.28876 6.06641 3.69118 6.06641 4.08893C6.06641 4.5304 6.41501 4.87636 6.86005 4.87636Z" :fill="color"/>
    <path d="M7.40332 5.54004H5.38281V6.36199H6.56566L6.57421 9.60875H5.42777V10.4305H8.60235V9.60875H7.39695L7.40332 5.54004Z" :fill="color"/>
  </svg>
</template>

<script>
export default {
  name: "IconInfo",
  props: {
    color: {
      type: String,
      default: '#828282'
    }
  }
}
</script>
